import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { CustomErrorHandlerService } from '../services/custom-error-handler.service';

export const customErrorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const customErrorHandler = inject(CustomErrorHandlerService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      customErrorHandler.processHttpError(req.url, error);

      return throwError(() => error);
    })
  );
};
